<template>
    <div class="banner-container">
        <div class="logo-box">
            <div class="title-box">
                <img src="~@/assets/imgs/logoW.png" alt="" srcset="">
                <span>华艺元界</span>
            </div>
            <div class="desc-box">
                <span>
                   链上华艺，元启未来
                </span>
            </div>
            <div class="desc-box2">
                <p>打造开放包容的平台，</p>
                <p>为所有热爱艺术的人群服务，</p>
                <p>为各个领域流派的艺术家服务，</p>
                <p>为多元共生的艺术文化交流而服务，</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.banner-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-image: url('~@/assets/img/m-banner.jpg');
    background-size: cover;
    .logo-box{
        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        align-items: center;
        .title-box{
            width: 100%;
            height: auto;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            img{
                width: 80px;
                height: 80px;
            }
            span{
                text-indent: 1rem;
                font-size: 48px;
                font-weight: 600;
            }
        }
        .desc-box{
            width: 100%;
            height: auto;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            span{
                text-indent: 1rem;
                font-size: 38px;
                font-weight: 600;
                line-height: 1.5;
            }
        }
        .desc-box2{
            width: auto;
            height: auto;
            color: #fff;
            border: 1px solid #fff;
            border-radius: 50px;
            margin-top: 20px;
            padding: 20px 20px;
            p{
                text-align: center;
                font-size: 18px;
                font-weight: 600;
                line-height: 1.5;
            }
        }

    }

}
</style>